import { Link } from 'react-router-dom';

import { createUrl } from 'app/utils';
import { Button } from 'components';

import { DashboardAreaColorEnum, DashboardAreaSubjectEnum, SchoolDashboardArea } from 'features/dashboard-new';
import { ColorsTypes } from 'styled-components';
import { useSchool } from 'features/school';

interface ButtonMoreProps {
  area: SchoolDashboardArea;
}

const ButtonMore = ({ area }: ButtonMoreProps) => {
  const { schoolAlias } = useSchool();

  let areaMoreLabel = 'Ver tudo';
  let areaMoreLink = '';
  let showButton = true;
  let buttonColor: ColorsTypes = 'primary_400';
  let buttonColorHover: ColorsTypes = 'primary_200';

  if (schoolAlias === 'b3') {
    if (area.dashboardAreaColor !== DashboardAreaColorEnum.Dark) {
      buttonColor = 'dark_350';
      buttonColorHover = 'dark_150';
    }
  }

  switch (area.dashboardAreaSubject) {
    case DashboardAreaSubjectEnum.AnalysisReports:
      areaMoreLink = `${createUrl('reportsList')}?dashboardAreaUuid=${area.uuid}`;
      break;

    case DashboardAreaSubjectEnum.Recommendations:
    case DashboardAreaSubjectEnum.LiveVideos:
    case DashboardAreaSubjectEnum.AvailablePrograms:
    case DashboardAreaSubjectEnum.EnrolledPrograms:
    case DashboardAreaSubjectEnum.EnrolledMasterClasses:
    case DashboardAreaSubjectEnum.AvailableMasterClasses:
    case DashboardAreaSubjectEnum.EnrolledJourneys:
    case DashboardAreaSubjectEnum.AvailableJourneys:
    case DashboardAreaSubjectEnum.Ebooks:
    case DashboardAreaSubjectEnum.EnrolledEvents:
    case DashboardAreaSubjectEnum.AvailableEvents:
      areaMoreLink = createUrl('dashboard/area', [area.uuid, area.uuid]);
      showButton = area?.hasMoreCards;
      break;

    case DashboardAreaSubjectEnum.SpeficicProgram:
      areaMoreLink = `${createUrl('programDetails', [area.productSlug])}?dashboardAreaUuid=${area.uuid}`;
      break;

    case DashboardAreaSubjectEnum.EnrolledCourses:
      areaMoreLink = area?.isPredefinedOrder
        ? createUrl('dashboard/area', [area.uuid, area.uuid])
        : `${createUrl('myCourses')}?dashboardAreaUuid=${area.uuid}`;
      showButton = area?.hasMoreCards;
      break;

    case DashboardAreaSubjectEnum.AvailableCourses:
      areaMoreLink = area?.isPredefinedOrder
        ? createUrl('dashboard/area', [area.uuid, area.uuid])
        : `${createUrl('productsList')}?dashboardAreaUuid=${area.uuid}`;
      break;

    case DashboardAreaSubjectEnum.PracticeExams:
      areaMoreLink = `${createUrl('exams/list')}?dashboardAreaUuid=${area.uuid}`;
      showButton = area?.hasMoreCards;
      break;
  }

  return showButton && areaMoreLink ? (
    <Link to={areaMoreLink}>
      <Button color={buttonColor} colorHover={buttonColorHover} bg="transparent" p={0} height="inherit">
        {areaMoreLabel}
      </Button>
    </Link>
  ) : (
    <></>
  );
};

export default ButtonMore;
